import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

const useCedoliniRealtime = ({ anno, mese, enabled = true, onChange }) => {
  const [connected, setConnected] = useState(false);
  const callbackRef = useRef(onChange);
  const timerRef = useRef(null);

  useEffect(() => { callbackRef.current = onChange; }, [onChange]);

  useEffect(() => {
    if (!enabled) return undefined;
    const defaultApiBaseUrl = process.env.NODE_ENV === 'development'
      ? 'http://localhost:3002/api/'
      : 'https://crm.millergroup.it/api/';
    const apiBaseUrl = process.env.REACT_APP_BASE_URL || defaultApiBaseUrl;
    const basename = process.env.REACT_APP_BASENAME || '';
    const socket = io(new URL(apiBaseUrl, window.location.origin).origin, {
      path: `${basename}/socket.io/`.replace('//', '/'),
      withCredentials: true,
    });
    const subscription = { anno: Number(anno), mese: Number(mese) };

    socket.on('connect', () => {
      setConnected(true);
      socket.emit('subscribe:cedolini', subscription);
    });
    socket.on('disconnect', () => setConnected(false));
    socket.on('connect_error', () => setConnected(false));
    socket.on('cedolini:changed', (event) => {
      if (Number(event?.anno) !== subscription.anno || Number(event?.mese) !== subscription.mese) return;
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => callbackRef.current?.(event), 120);
    });

    return () => {
      clearTimeout(timerRef.current);
      socket.emit('unsubscribe:cedolini', subscription);
      socket.disconnect();
      setConnected(false);
    };
  }, [anno, mese, enabled]);

  return connected;
};

export default useCedoliniRealtime;
